<template>
  <div>
    <base-title :title="StringLanguage.productsSold" :subtitle="StringLanguage.reports" :link="'relatorios'" />

    <base-empty
      v-if="isEmpty()"     
      title="Não há nenhum produto vendido."
      message="Todos os produtos vendidos irão aparecer aqui."
    />

    <div class="row" v-else>
      <div class="col-xs-12 col-md-6" :class="!isMobile && 'pr_10'">
        <table-box
          title="Produtos mais pedidos"
          :headers="['Nome do produto', 'Ocorrências']"
          :items="ranking.products ? ranking.products : []"
        />
      </div>
      <div class="col-xs-12 col-md-6" :class="isMobile ? 'top-negative' : 'pl_10'">
        <table-box
          title="Categorias mais pedidas"
          :headers="['Nome da categoria', 'Ocorrências']"
          :items="ranking.categories ? ranking.categories : []"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseTitle from "@/components/Title";
import BaseEmpty from '@/components/Empty';
import TableBox from "@/containers/TableBox";
import dayjs from "dayjs";
import ApiReports from "@/api/reports";
import { mapState } from "vuex";

export default {
  components: {
    BaseTitle,
    TableBox,
    BaseEmpty
  },
  data () {
    return {
      dayjs,
      ranking: {},
      period: {
        default: [
          dayjs().format("YYYY-MM-[01] 00:00:00"),
          `${dayjs().format("YYYY-MM")}-${dayjs().daysInMonth()} 23:59:59`,
        ],
        ordersGrowth: [
          dayjs().format("YYYY-MM-[01] 00:00:00"),
          `${dayjs().format("YYYY-MM")}-${dayjs().daysInMonth()} 23:59:59`,
        ],
        customerGrowth: [
          dayjs().format("YYYY-MM-[01] 00:00:00"),
          `${dayjs().format("YYYY-MM")}-${dayjs().daysInMonth()} 23:59:59`,
        ],
      },
    }
  },
  mounted () {
    this.getReport()
  },
  methods: {
    isEmpty() {
      return this.ranking.products.length == 0 && this.ranking.categories.length == 0
    },
    async getReport () {
      const esFilter = {
        query: [
          {
            index: "report-customers",
            type: "aggs",
            queries: [
              {
                bool: {
                  should: [
                    {
                      match: {
                        type: "M",
                      },
                    },
                    {
                      match: {
                        type: "L",
                      },
                    },
                  ],
                },
              },
            ],
            aggs: {
              customers_total: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: dayjs(new Date("1901-01-01")).format(
                        "YYYY-MM-DDTHH:mm:ssZ[Z]"
                      ),
                      to: dayjs(new Date()).format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                    },
                  ],
                },
              },
              customers_currently: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: dayjs(this.period.customerGrowth[0]).format(
                        "YYYY-MM-DDTHH:mm:ssZ[Z]"
                      ),
                      to: dayjs(this.period.customerGrowth[1]).format(
                        "YYYY-MM-DDTHH:mm:ssZ[Z]"
                      ),
                    },
                  ],
                },
                aggs: {
                  customers_per_day: {
                    date_histogram: {
                      field: "created_at",
                      interval: "day",
                      min_doc_count: 1,
                    },
                  },
                },
              },
              customers_previous: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: dayjs(this.period.customerGrowth[0])
                        .subtract(1, "month")
                        .format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                      to: dayjs(this.period.customerGrowth[1])
                        .subtract(1, "month")
                        .format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                    },
                  ],
                },
                aggs: {
                  customers_per_day: {
                    date_histogram: {
                      field: "created_at",
                      interval: "day",
                      min_doc_count: 1,
                    },
                  },
                },
              },
            },
          },
          {
            index: "report-orders",
            type: "aggs",
            queries: [
              {
                match: {
                  status: 4,
                },
              },
            ],
            aggs: {
              orders_currently: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: dayjs(this.period.ordersGrowth[0]).format(
                        "YYYY-MM-DDTHH:mm:ssZ[Z]"
                      ),
                      to: dayjs(this.period.ordersGrowth[1]).format(
                        "YYYY-MM-DDTHH:mm:ssZ[Z]"
                      ),
                    },
                  ],
                },
                aggs: {
                  orders_per_day: {
                    date_histogram: {
                      field: "created_at",
                      interval: "day",
                      min_doc_count: 1,
                    },
                  },
                },
              },
              orders_previous: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: dayjs(this.period.ordersGrowth[0])
                        .subtract(1, "month")
                        .format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                      to: dayjs(this.period.ordersGrowth[1])
                        .subtract(1, "month")
                        .format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                    },
                  ],
                },
                aggs: {
                  orders_per_day: {
                    date_histogram: {
                      field: "created_at",
                      interval: "day",
                      min_doc_count: 1,
                    },
                  },
                },
              },
              categories_and_products: {
                nested: {
                  path: "items",
                },
                aggs: {
                  categories: {
                    terms: {
                      field: "items.category",
                      size: 10000,
                    },
                  },
                  products: {
                    terms: {
                      field: "items.name",
                      size: 10000,
                    },
                    aggs: {
                      flavors: {
                        nested: {
                          path: "items.flavors",
                        },
                        aggs: {
                          flavors: {
                            terms: {
                              field: "items.flavors.name",
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              order_regions: {
                terms: {
                  field: "delivery.region",
                },
                aggs: {
                  geolocation: {
                    top_hits: {
                      _source: {
                        includes: ["delivery.geolocation"],
                      },
                      size: 1,
                    },
                  },
                  customers: {
                    top_hits: {
                      _source: {
                        includes: ["payers.user.id"],
                      },
                    },
                  },
                },
              },
            },
          },
          {
            index: "report-orders",
            type: "aggs",
            queries: [
              {
                bool: {
                  should: [
                    {
                      match: {
                        status: 4,
                      },
                    },
                    {
                      match: {
                        status: -1,
                      },
                    },
                  ],
                },
              },
            ],
            aggs: {
              orders_total: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: dayjs(new Date("1901-01-01")).format(
                        "YYYY-MM-DDTHH:mm:ssZ[Z]"
                      ),
                      to: dayjs(new Date()).format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                    },
                  ],
                },
              },
            },
          },
          {
            index: "report-rating-orders",
            type: "aggs",
            aggs: {
              rating_total: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: dayjs(new Date("1901-01-01")).format(
                        "YYYY-MM-DDTHH:mm:ssZ[Z]"
                      ),
                      to: dayjs(new Date()).format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                    },
                  ],
                },
              },
              rating: { avg: { field: "rating_average" } },
            },
          },
        ],
      };

      const apiResponse = await ApiReports.reports(esFilter)

      this.ranking.categories = apiResponse.data[1].categories_and_products.categories.buckets.map(
        (item) => {
          return { name: item.key, value: item.doc_count }
        }
      )

      const subitems = [];
      const products = [];

      apiResponse.data[1].categories_and_products.products.buckets.forEach(
        (item) => {
          if (item.flavors.doc_count) {
            item.flavors.flavors.buckets.forEach((subitem) => {
              subitems.push({ name: subitem.key, value: subitem.doc_count })
            })
            return
          }
          return products.push({ name: item.key, value: item.doc_count })
        }
      )

      const groupProducts = subitems.reduce((result, item) => {
        result[item.name]
          ? (result[item.name] += item.value)
          : (result[item.name] = item.value)
        return result
      }, {})

      for (const i in groupProducts) {
        products.push({ name: i, value: groupProducts[i] })
      }

      this.ranking.products = (products || []).sort((a, b) => b.value - a.value)

      this.$forceUpdate()
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile
    }),
  }
}
</script>

<style scoped>
.top-negative {
  margin-top: -10px;
}
</style>
